import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Ana Rodrigues",
    role: "Empregada de Mesa",
    location: "Lisboa",
    text: "Encontrei trabalho em 4 dias. A análise do CV pela IA mostrou-me exatamente o que faltava no meu perfil. Nunca pensei que fosse tão simples.",
    avatar: "AR",
    color: "bg-amber-500",
    rating: 5,
  },
  {
    name: "Carlos Mendes",
    role: "Motorista de Distribuição",
    location: "Porto",
    text: "Comparado com outros portais, a qualidade das vagas aqui é muito melhor. Candidatei-me a três vagas e fui chamado para entrevista em duas.",
    avatar: "CM",
    color: "bg-sky-600",
    rating: 5,
  },
  {
    name: "Sofia Lopes",
    role: "Gestora de Loja",
    location: "Braga",
    text: "Como empresa, publicamos uma vaga à segunda e na quarta já tínhamos 12 candidatos triados pela IA. O match score poupou-nos imenso tempo.",
    avatar: "SL",
    color: "bg-emerald-600",
    rating: 5,
  },
];

function StarsRow({ rating }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`w-3.5 h-3.5 ${i <= rating ? "fill-amber-400 text-amber-400" : "text-slate-200"}`} />
      ))}
    </div>
  );
}

export const Testimonials = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
    <div className="text-center mb-12">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-amber-600 mb-3">Testemunhos reais</p>
      <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl text-slate-900">
        Quem já encontrou o seu lugar
      </h2>
      <p className="text-slate-600 mt-3 max-w-xl mx-auto">
        Candidatos e empresas em Portugal que usam o FIRST2JOB para crescer.
      </p>
    </div>
    <div className="grid md:grid-cols-3 gap-6">
      {TESTIMONIALS.map((t) => (
        <div key={t.name}
          className="bg-white rounded-2xl border border-black/5 p-7 hover:shadow-lg hover:-translate-y-1 transition-all flex flex-col">
          <StarsRow rating={t.rating} />
          <blockquote className="text-slate-700 text-sm leading-relaxed mt-4 flex-1">
            &ldquo;{t.text}&rdquo;
          </blockquote>
          <div className="flex items-center gap-3 mt-6 pt-5 border-t border-black/5">
            <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-sm shrink-0`}>
              {t.avatar}
            </div>
            <div>
              <p className="text-sm font-semibold text-slate-900">{t.name}</p>
              <p className="text-xs text-slate-500">{t.role} · {t.location}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
